import { render, staticRenderFns } from "./ItemChipReviewNew.vue?vue&type=template&id=29717235&scoped=true"
import script from "./ItemChipReviewNew.vue?vue&type=script&lang=ts"
export * from "./ItemChipReviewNew.vue?vue&type=script&lang=ts"
import style0 from "./ItemChipReviewNew.vue?vue&type=style&index=0&id=29717235&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29717235",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29717235')) {
      api.createRecord('29717235', component.options)
    } else {
      api.reload('29717235', component.options)
    }
    module.hot.accept("./ItemChipReviewNew.vue?vue&type=template&id=29717235&scoped=true", function () {
      api.rerender('29717235', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ItemChipReviewNew.vue"
export default component.exports